import React from 'react';

import type { Props as LinkProps } from 'Elements/Link';

import { Wrapper, Background, DefaultWave, AltWave, PromoLink } from './Link.styled';

export interface Props {
    defaultWave?: boolean;
    className?: string;
    link: LinkProps;
}

const BannerLink: React.FC<Props> = props => {
    const { defaultWave = true, link, className = '' } = props;

    return (
        <Wrapper className={`banner link-banner ${className}`.trim()}>
            <Background>{defaultWave ? <DefaultWave /> : <AltWave />}</Background>
            <PromoLink variant="threeDark" {...link} />
        </Wrapper>
    );
};

export default BannerLink;
